import { shared } from '@tig-dpqa-cloud/contract-backend-common';
import { z } from 'zod';

export const GenericAnonRecordsGetPathParams = z.object({
  tenantId: shared.TenantId,
});
export type GenericAnonRecordsGetPathParamsType = z.infer<typeof GenericAnonRecordsGetPathParams>;

export const GenericAnonRecordsGetQuery = z.object({
  requestedAt: z
    .iso.date()
    .optional()
    .describe('Date used to retrieve records for the corresponding tenant-local day.'),

  filterIds: z.string().optional().describe('Comma-separated filter IDs'),
});
export type GenericAnonRecordsGetQueryType = z.infer<typeof GenericAnonRecordsGetQuery>;

export const GenericAnonRecordGetResponseItem = z.object({
  id: z.string().min(1),
  tenantId: shared.TenantId,
  slideScanId: z.string().min(1),
  anonymizationId: z.string().min(1),
  filterIds: z.array(z.string()),
  status: z.string(),
  requestedAt: z.date().transform((d) => d.toISOString()),
});
export type GenericAnonRecordGetResponseItemType = z.infer<typeof GenericAnonRecordGetResponseItem>;

export const GenericAnonRecordsGetResponse = z.array(GenericAnonRecordGetResponseItem);
export type GenericAnonRecordsGetResponseType = z.infer<typeof GenericAnonRecordsGetResponse>;
